import React from 'react';
import PropTypes from 'prop-types';
import SvgImage from '../svg-image';

/**
 * The chrome every sign-in screen shares: the logo, a title, and one thing to read.
 *
 * Pulled out because the flow is several screens that differ only in the middle — putting the
 * frame in one place is what keeps the logo from drifting a few pixels between steps.
 */
const AuthCard = ({ title, subtitle, mark, children }) => (
	<div className="px-auth-card">
		<div className="px-auth-card-logo">
			<SvgImage use="pixwelLg"/>
		</div>

		{mark ? <div className="px-auth-card-mark">{mark}</div> : null}

		<h3 className="px-auth-card-title">{title}</h3>
		{subtitle ? <p className="px-auth-card-subtitle">{subtitle}</p> : null}

		{children}
	</div>
);

AuthCard.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.node,
	mark: PropTypes.node,
	children: PropTypes.node
};

/**
 * A fingerprint, for the screens about a passkey. Drawn rather than borrowed: the gesture is a
 * fingerprint, a face or a PIN depending on the device, and this is the one people recognise.
 */
export const FingerprintMark = () => (
	<svg
		viewBox="0 0 24 24"
		aria-hidden="true"
		focusable="false"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
	>
		<path d="M12 2.5c-2.2 0-4.2.8-5.7 2.2"/>
		<path d="M3.6 7.4A9.4 9.4 0 0 0 2.5 12"/>
		<path d="M12 6.2a5.8 5.8 0 0 0-5.8 5.8c0 1.2.1 2.4.4 3.5"/>
		<path d="M17.8 12a5.8 5.8 0 0 0-2.6-4.8"/>
		<path d="M12 9.8A2.2 2.2 0 0 0 9.8 12c0 2.6.4 5.1 1.2 7.5"/>
		<path d="M14.2 12c0 3 .5 6 1.5 8.8"/>
		<path d="M18.4 15.5c.3 1.6.8 3.2 1.4 4.7"/>
		<path d="M6.6 19.5c-.5-1.4-.8-2.9-1-4.4"/>
	</svg>
);

/**
 * The little triangle on the primary button, as a glyph rather than a character so it keeps its
 * size and colour with the label.
 */
export const PlayMark = () => (
	<svg
		viewBox="0 0 8 10"
		aria-hidden="true"
		focusable="false"
		fill="currentColor"
		className="h-3 w-3 flex-shrink-0"
	>
		<path d="M0 0l8 5-8 5z"/>
	</svg>
);

/**
 * A pencil, for changing the address without a word for it.
 */
export const PencilMark = () => (
	<svg
		viewBox="0 0 16 16"
		aria-hidden="true"
		focusable="false"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M11.5 1.5l3 3-8 8H3.5v-3z"/>
	</svg>
);

export default AuthCard;
